import { ExclamationTriangleIcon, UserMinusIcon, UserPlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useRef, useState } from "react";
import { useClickOutsideBlock } from "../../helpers/useClickOutside";
import { LoaderSpinner } from "../LoaderSpinner";

export const EnableAccessModal = ({
    isOpen,
    isLoading,
    user,
    cancelClick,
    submitClick,
}) => {
    const modalRef = useRef(null);
    useClickOutsideBlock(modalRef, cancelClick);
    if (!isOpen) return null;
    return (
        <div aria-hidden="true" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full">
            <div className="bg-gray-700 top-0 right-0 left-0 fixed z-40 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full opacity-30" />
            <div ref={modalRef} className={`relative p-5 w-full max-w-lg max-h-full bg-white border top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 rounded-md`}>
                <div className="flex justify-end">
                    <button 
                        onClick={cancelClick}
                        className="inline-flex items-center p-1 text-primary absolute"
                    >
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                    </button>
                </div>
                <div className="flex flex-col gap-4 text-center sm:text-left">
                    <h2 className="text-lg leading-none font-semibold flex items-center gap-2">
                        <UserPlusIcon className="h-6 w-6 text-green-500"/>
                        <span>Enable User Access</span>
                    </h2>
                    <p className="text-gray-700/90 text-sm">
                        This will restore {user?.name || ""}'s access to the system with their existing permissions.
                    </p>
                </div>
                <div className="space-y-4 my-4">
                    <div className="relative w-full rounded-lg border px-4 py-3 text-sm grid gap-2 items-start text-gray-700/60 bg-gray-100">
                        <ExclamationTriangleIcon className="h-5 w-5 text-gray-700/60" />
                        <div className="text-gray-700/80 col-start-2 grid justify-items-start gap-1 text-sm">
                            <strong>{user?.name || ""}</strong>
                            <p>
                                will regain access to all their previously assigned tabs and permissions.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2">
                    <button 
                        onClick={() => {
                            cancelClick()
                        }}
                        className="min-w-20 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm"
                    >
                        {isLoading ? <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray"/> : "Cancel"}
                    </button>
                    <button 
                        onClick={() => {
                            if (!isLoading) {
                                submitClick(user?.id);
                            }
                        }}
                        className="min-w-24 justify-center inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                        {isLoading ? <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray"/> : "Enable Access"}
                    </button>
                </div>
            </div>
        </div>
    )
}